<script lang='ts'>
  import { Icon, Input, InputGroup, Popover } from "sveltestrap"
  import { containsService, paramsService, subtypesDiligencesService } from "../services"
  import { createEventDispatcher } from 'svelte';
  import type { SubtypesDiligences } from "../Model/SubtypesDiligences"
    import ParamSelect from "./ParamSelect.svelte";

const dispatch = createEventDispatcher();

  export let searchFilterComponent = {
      register : null,
      selectRegister : null,
      selectObject : null,
      date : null
  };

  let inputRegister = null;
  let selectRegister = null;
  let selectDate = null;
  let selectObject = null;
  let startDate = null;
  let endDate = null;
  
  let date = new Date();

  function load(searchFilter) {
    dispatch('load', searchFilter);
  }

  loadInputDate();

    function loadInputDate() {
        let startMonth = '0'; 
        let month = '0';
        if (date.getMonth() < 10 ) {
            month += date.getMonth()+1;
            startMonth += date.getMonth();
        } else {
            month = `${date.getMonth() + 1}`;
            startMonth = `${date.getMonth()}`;
        }
        let year = date.getFullYear()
        let day = date.getDate()

        startDate = year + '-' + startMonth + '-' + day;
        endDate = year + '-' + month + '-' + day;

        let selectedDates = [startDate, endDate];
        loadData(selectedDates,'date');
    }

  function loadData(data, type) {
        if (type == 'register') {
            searchFilterComponent.register = data;
        } else if (type == 'selectRegister') {
            if(data == null) {
                searchFilterComponent.selectRegister = 'both';
                inputRegister = null;
                searchFilterComponent.register = null;
            } else {
                searchFilterComponent.selectRegister = data;
            }
        } else if (type == 'selectObject') {
            searchFilterComponent.selectObject = data;
        }else {
            if (selectDate == null) {
                searchFilterComponent.selectRegister = 'both';
                searchFilterComponent.date = data;
            } else{
                searchFilterComponent.date = data;
            }
            
        }
        load(JSON.stringify(searchFilterComponent));
    }

    function replaceDate() {
        let popover = document.getElementById('popover');
        popover.hidden = true;
        
        let selectedDates = [startDate, endDate];
        loadData(selectedDates,'date');
    }

    function clearFilter() {
        searchFilterComponent = {
            register : null,
            selectRegister : null,
            selectObject : null,
            date : null
        };
        inputRegister = null;
        selectObject = null;
        loadInputDate();
    }
</script>

<div class="container mt-3">
  <div class="row">
      <div class="col-3 col-sm-3 mb-3">
          <!-- Select para tipo de registro a filtrar -->
          <select bind:value={selectRegister} on:change={() => loadData(selectRegister,'selectRegister')} class='form-select'>
              <option value={null} selected>Seleccionar registro</option>
              <option value='both'>Ambos</option>
              <option value='registerIn'>Entrada</option>
              <option value='registerOut'>Salida</option>
          </select>
      </div>
      <!-- Input para colocar el número del registro -->
      <div class="col-3 col-sm-3 mb-3">
          <form on:submit|preventDefault={() => loadData(inputRegister,'register')}>
              <InputGroup>
                  <Input placeholder="Encuentra un registro" bind:value={inputRegister} />
                  <button type="submit" class="btn btn-primary"><Icon name="search" /></button>
              </InputGroup>
          </form>
      </div>
      <!-- Select para filtrar por delito -->
      <div class="col-3 col-sm-3 mb-3">
          <ParamSelect bind:paramSelectId={selectObject} paramType='objectType' nothing={true} on:changed={(e) => {loadData(e.detail, 'selectObject')}}/>
      </div>
      <!-- Input para espcificar el rango de fechas para filtrar -->
      <div class="col-3 col-sm-3 mb-3 d-flex">
          
            <button class='btn border border-dark' id='pop'>
                {startDate} - {endDate}
            </button>
            <Popover placement="bottom" target="pop" id='popover'>
                <div id='startDate'>
                    <p>Desde:</p>
                    <Input
                        type='date'
                        bind:value={startDate}
                    />
                </div>
                <div id='endDate'>
                    <p>Hasta</p>
                    <Input
                        type='date'
                        bind:value={endDate}
                    />
                </div>
                <button class='btn btn-primary mt-3' on:click={replaceDate}>Buscar</button>
            </Popover>

          <button class='btn btn-primary ms-1' on:click={clearFilter}><Icon name='eraser' /></button>
      </div>
  </div>
</div>
